var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery-step"},[_c('span',{staticClass:"gallery-step__active"},[_vm._t("active")],2),_vm._v(" / "),_vm._t("length")],2)}
var staticRenderFns = []

export { render, staticRenderFns }